import { InstagramPosts } from './InstagramPosts';
export default InstagramPosts;
